import React from 'react';
import './statement.scss';

export const Statement = () => {
  return (
    <div className="statement">
      <p>
        Našim cílem je pomáhat zákazníkům zvyšovat efektivitu a chránit jejich
        činnosti a podnikání.
      </p>
      <p>
        Správná strategie je v IT klíčem k úspěšnému a efektivnímu využívání
        zdrojů a celkovému úspěchu firmy.
      </p>
    </div>
  );
};
